import { inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';

export const authErrorInterceptor = (req: any, next: any) => {
  const router = inject(Router);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403 || error.status === 401) {
        const errorCode = error.error?.errorCode ||
          (error.status === 403 ? 'GENERAL_ACCESS_DENIED' : 'AUTHENTICATION_FAILED');
        router.navigate(['/access-denied'], { queryParams: { errorCode } });
      }
      return throwError(() => error);
    })
  );
};
